<template>
    <div>
        <div class="gradient-box gradient-box-peach" />
        <div class="row" data-test-view="goals">
            <div
                class="col-md-2 hidden-xs hidden-sm mouseover-parent goals-side-menu"
                :class="{
                    'hidden-xs hidden-md hidden-lg hidden-xlg': view === 'goal' || !showMenu,
                }"
            >
                <l-side-menu>
                    <l-side-menu-picture :src="icon"></l-side-menu-picture>

                    <l-side-menu-element
                        v-for="item in menu"
                        :key="item.name"
                        :show="item.show"
                        :type="item.type"
                        :icon="item.icon"
                        :label="item.label"
                        :path="item.path"
                        :handler="
                            () => {
                                if (item.handler) {
                                    item.handler();
                                    return;
                                }

                                goTo(item.path);
                            }
                        "
                        :active="item.active"
                    ></l-side-menu-element>

                    <div
                        v-if="view !== 'cycle'"
                        class="tw-flex tw-space-x-2 tw-mt-6 tw-border-solid tw-border-0 tw-border-t-2 tw-pt-6 tw-border-gray-200"
                    >
                        <div
                            v-b-popover.hover.top="$t('goals.list.btnShowAsList')"
                            class="tw-flex-1 sidebar-menu-button tw-cursor-pointer"
                            :class="{ 'sidebar-menu-button-active': section === 'list' }"
                            @click="showView('list')"
                            @keyup.enter="showView('list')"
                        >
                            <i class="fal fa-list"></i>
                        </div>
                        <div
                            v-b-popover.hover.top="$t('goals.list.btnShowStats')"
                            class="tw-flex-1 sidebar-menu-button tw-cursor-pointer"
                            :class="{ 'sidebar-menu-button-active': section === 'stats' }"
                            @click="showView('stats')"
                            @keyup.enter="showView('stats')"
                        >
                            <i class="fal fa-chart-line"></i>
                        </div>
                        <div
                            v-if="rights.G_VIEW_TREE"
                            v-b-popover.hover.top="$t('goals.list.btnPartialTree')"
                            class="tw-flex-1 sidebar-menu-button tw-cursor-pointer"
                            :class="{ 'sidebar-menu-button-active': section === 'tree' }"
                            @click="showView('tree')"
                            @keyup.enter="showView('tree')"
                        >
                            <i class="fal fa-sitemap"></i>
                        </div>
                        <div
                            v-b-popover.hover.top="$t('goals.list.btnShowFeed')"
                            class="tw-flex-1 sidebar-menu-button tw-cursor-pointer"
                            :class="{ 'sidebar-menu-button-active': section === 'feed' }"
                            @click="showView('feed')"
                            @keyup.enter="showView('feed')"
                        >
                            <i class="fal fa-bell"></i>
                        </div>
                    </div>
                </l-side-menu>
            </div>
            <div :class="[view === 'goal' || !showMenu ? 'col-md-12' : 'col-md-10']">
                <router-view
                    @section="updateSection"
                    @create="createNewGoal"
                    @toggleMenu="toggleMenu"
                ></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ObjectId from "bson-objectid";
import LSideMenu from "@/components/LSideMenu";
import LSideMenuElement from "@/components/LSideMenuElement";
import LSideMenuPicture from "@/components/LSideMenuPicture";

import icon from "@/img/icons/goals.png";

export default {
    components: {
        LSideMenu,
        LSideMenuElement,
        LSideMenuPicture,
    },
    props: {},
    data() {
        return {
            section: "list", // "list" | "stats" | "feed" | "tree"
            view: "list", // "list" | "stats" | "feed" | "tree" | "goal" | "cycle",
            showMenu: true,
        };
    },
    computed: {
        ...mapGetters({
            rights: "users/current/rights",
        }),
        menu() {
            const qs = this.$route.fullPath.split("?")[1] ?? "";

            return [
                {
                    show: true,
                    label: this.$t("goals.list.menuMyGoals"),
                    path: `/goals/${this.section}/user?${qs}`,
                    active: this.segment === "user",
                    name: "userParent",
                },
                {
                    show: true,
                    label: this.$t("goals.list.menuMyTeam"),
                    path: `/goals/${this.section}/team?${qs}`,
                    active: this.segment === "team",
                    name: "teamParent",
                },
                {
                    show: this.rights.G_VIEW_TREE,
                    label: this.$t("goals.list.menuCompanyTeam"),
                    path: `/goals/${this.section}/company?${qs}`,
                    active: this.segment === "company",
                    name: "companyParent",
                },
                {
                    show: true,
                    label: this.$t("goals.list.menuExtendedTeam"),
                    path: `/goals/${this.section}/all?${qs}`,
                    active: this.segment === "all",
                    name: "allParent",
                },
                {
                    show: Boolean(this.cyclesCount) || this.rights.G_CYCLE_ADMIN,
                    label: this.$t("goals.list.menuGoalCycles"),
                    path: `/goals/cycles/list`,
                    active: this.view === "cycle",
                    name: "cyclesParent",
                    handler: () => {
                        this.view = "cycle";
                        this.$router.push(`/goals/cycles/list`);
                    },
                },
            ];
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                if (route.path.startsWith("/goals/cycles/")) {
                    this.view = "cycle";
                    this.section = "list";
                    this.segment = "";
                } else if (route.path.startsWith("/goals/list/")) {
                    this.section = "list";
                    this.segment = this.$route.params.segment;
                } else if (route.path.startsWith("/goals/stats/")) {
                    this.section = "stats";
                    this.segment = this.$route.params.segment;
                } else if (route.path.startsWith("/goals/feed/")) {
                    this.section = "feed";
                    this.segment = this.$route.params.segment;
                } else if (route.path.startsWith("/goals/tree/")) {
                    this.section = "tree";
                    this.segment = this.$route.params.segment;
                }
            },
        },
    },
    created() {
        this.icon = icon;
    },
    methods: {
        goTo(path) {
            this.$router.push(path);
        },
        showView(view) {
            this.view = view;
            const qs = this.$route.fullPath.split("?")[1] ?? "";
            const path = `/goals/${view}/${this.segment}?${qs}`;
            this.goTo(path);
        },
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        updateSection(section) {
            this.view = section;
        },

        // Used to create an empty new goal, or copy an existing goal
        createNewGoal(goal = {}) {
            const id = ObjectId().toString();

            this.$store.dispatch({
                type: "goals/goals/create",
                payload: {
                    goal: {
                        ...goal,
                        _id: id,
                        isNew: true,
                    },
                },
            });

            this.$router.push(`/goals/edit/${id}`);
        },
    },
};
</script>

<style scoped>
.goals-side-menu >>> .search-input {
    background-color: #ffffff;
}
</style>
